import React from 'react';
import { DiReact } from 'react-icons/di';

const Footer = () => (
  <footer>
    <p>2023 &copy; mathmagicians.com</p>
    <DiReact className="react-icon" />
  </footer>
);

export default Footer;
